module.exports = __webpack_public_path__ + "img/21.3babf0a4.jpg";